module.exports = __webpack_public_path__ + "static/img/COC2023-21.dc58171.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/meeting2023/COC2023-21.png
// module id = E8Rw
// module chunks = 0